<template>
  <section v-show="visible" class="catalog-search-panel" :style="{ top: headerBottom + 'px' }" :aria-label="$t('search.language_0')">
    <Search v-if="visible" ref="search" embedded @closeSearch="close" />
  </section>
</template>

<script>
import Search from './index.vue'

export default {
  name: 'SearchDialog',
  components: { Search },
  props: {
    visible: { type: Boolean, default: false },
    getHeaderElement: { type: Function, required: true }
  },
  data: () => ({ headerBottom: 0, headerObserver: null }),
  watch: {
    visible(open) {
      if (!open) {
        if (this.headerObserver) this.headerObserver.disconnect()
        return
      }
      this.updatePosition()
      const header = this.getHeaderElement()
      if (header && this.headerObserver) this.headerObserver.observe(header)
      this.$nextTick(() => { if (this.$refs.search) this.$refs.search.focusInput() })
    },
    '$route.fullPath'() { if (this.visible) this.close() }
  },
  mounted() {
    // Escape the navigation's scrolling container without covering the header.
    document.body.appendChild(this.$el)
    if (typeof ResizeObserver !== 'undefined') this.headerObserver = new ResizeObserver(this.updatePosition)
    window.addEventListener('resize', this.updatePosition)
    document.addEventListener('keydown', this.onKeydown)
  },
  beforeDestroy() {
    if (this.headerObserver) this.headerObserver.disconnect()
    window.removeEventListener('resize', this.updatePosition)
    document.removeEventListener('keydown', this.onKeydown)
    if (this.$el.parentNode) this.$el.parentNode.removeChild(this.$el)
  },
  methods: {
    updatePosition() {
      const header = this.getHeaderElement()
      if (header) this.headerBottom = header.getBoundingClientRect().bottom
    },
    close() { this.$emit('update:visible', false) },
    onKeydown(event) { if (this.visible && event.key === 'Escape') this.close() }
  }
}
</script>

<style scoped>
.catalog-search-panel {
  position: fixed;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 1000;
  overflow-y: auto;
  overscroll-behavior: contain;
  background: #fff;
  color: #222;
}
.catalog-search-panel /deep/ .embedded-search { min-height: 100%; }
</style>
